"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageType = exports.StorageItems = void 0;
var tslib_1 = require("tslib");
var js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
var StorageItems;
(function (StorageItems) {
    StorageItems["TOKEN"] = "token";
    StorageItems["REGION"] = "region";
    StorageItems["LANGUAGE"] = "i18next";
})(StorageItems || (exports.StorageItems = StorageItems = {}));
var StorageType;
(function (StorageType) {
    StorageType[StorageType["LocalStorage"] = 0] = "LocalStorage";
    StorageType[StorageType["Cookies"] = 1] = "Cookies";
})(StorageType || (exports.StorageType = StorageType = {}));
var CredentialsStorage = (function () {
    function CredentialsStorage(storageType) {
        this.type = storageType;
    }
    CredentialsStorage.prototype.setItem = function (itemName, value) {
        if (this.type === StorageType.LocalStorage) {
            this.setLocalStorage(itemName, value);
        }
        if (this.type === StorageType.Cookies) {
            this.setCookies(itemName, value);
        }
    };
    CredentialsStorage.prototype.getItem = function (itemName) {
        if (this.type === StorageType.LocalStorage) {
            return this.getFromLocalStorage(itemName);
        }
        if (this.type === StorageType.Cookies) {
            return this.getFromCookies(itemName);
        }
    };
    CredentialsStorage.prototype.clearItem = function (itemName) {
        if (this.type === StorageType.LocalStorage) {
            this.clearLocalStorage(itemName);
        }
        if (this.type === StorageType.Cookies) {
            this.clearCookies(itemName);
        }
    };
    CredentialsStorage.prototype.getFromLocalStorage = function (itemName) {
        return localStorage.getItem(itemName);
    };
    CredentialsStorage.prototype.getFromCookies = function (itemName) {
        return js_cookie_1.default.get(itemName);
    };
    CredentialsStorage.prototype.setLocalStorage = function (itemName, value) {
        localStorage.setItem(itemName, value);
    };
    CredentialsStorage.prototype.setCookies = function (itemName, value) {
        js_cookie_1.default.set(itemName, value);
    };
    CredentialsStorage.prototype.clearLocalStorage = function (itemName) {
        localStorage.removeItem(itemName);
    };
    CredentialsStorage.prototype.clearCookies = function (itemName) {
        js_cookie_1.default.remove(itemName);
    };
    return CredentialsStorage;
}());
exports.default = CredentialsStorage;
//# sourceMappingURL=credentials-storage.js.map